import { tab } from '@/views/setupCenter/@types/tab';
import { _ROUTER_NAME } from '@/enums';

export const tabs: tab[] = [
	{
		id: _ROUTER_NAME.SETUP_INFORMATION,
		name: 'Thông Tin Chung',
		icon: 'das--gear',
		link: '/setup-center',
		state: ['activated', 'community'],
	},
	{
		id: _ROUTER_NAME.SETUP_AUTHORIZATION,
		name: 'Phân quyền',
		icon: 'das--goal',
		link: '/setup-center/authorization',
		state: ['activated'],
	},
	{
		id: _ROUTER_NAME.SETUP_SCHEDULE,
		name: 'Lịch học',
		icon: 'das--calender',
		link: '/setup-center/schedule',
		state: ['activated'],
	},
	{
		id: _ROUTER_NAME.SETUP_TARGET_SMART,
		name: 'Mục tiêu',
		icon: 'das--goal',
		link: '/setup-center/target-smart',
		state: ['activated', 'community'],
	},
	{
		id: _ROUTER_NAME.SETUP_REPORT,
		name: 'Báo cáo',
		icon: 'das--report',
		link: '/setup-center/report',
		state: ['activated'],
	},
	{
		id: _ROUTER_NAME.SETUP_LUCA_AI,
		name: 'Tính năng khác',
		icon: 'das--ai',
		link: '/setup-center/luca-ai',
		state: ['activated'],
	},
	{
		id: _ROUTER_NAME.SETUP_OTHERS,
		name: 'Nhóm chat',
		icon: 'das--report',
		link: '/setup-center/others',
		state: ['activated', 'community'],
	},
];
